import { B1 } from "@/modules/common/fonts";
import styled from "@emotion/styled";
import { useTranslation } from "next-i18next";
import Slide from "@mui/material/Slide";
import Modal from "@mui/material/Modal";
import { useEffect } from "react";
import { EVENT, send } from "@/lib/amplitude";
import useDownload from "../useDownload";

const Popup = ({
  dubbedIdx,
  locale,
  showPopup,
  setShowPopup,
}: {
  dubbedIdx: number | string;
  locale: string;
  showPopup: boolean;
  setShowPopup: any;
}) => {
  const { t } = useTranslation();
  const { handleDownload } = useDownload();

  const random = Math.floor(Math.random() * 5) + 1;

  useEffect(() => {
    if (showPopup) {
      send(EVENT.OPEN__DOWNLOAD_APP_POPUP, {
        screen: "Dubbed",
        dubbed_idx: dubbedIdx,
      });
    }
  }, [showPopup, dubbedIdx]);

  const onClickDownload = () => {
    send(EVENT.CONFIRM__DOWNLOAD_APP_POPUP, {
      screen: "Dubbed",
      dubbed_idx: dubbedIdx,
    });
    handleDownload(locale);
  };

  const onClickClose = () => {
    send(EVENT.CLOSE__DOWNLOAD_APP_POPUP, {
      screen: "Dubbed",
      dubbed_idx: dubbedIdx,
    });

    setShowPopup(false);
  };

  return (
    <Modal open={showPopup} onClose={onClickClose} disableAutoFocus>
      <Wrapper>
        <Slide direction="up" in={showPopup}>
          <Box>
            <PopupImage src="/img/common/popup-img.png" />
            <ButtonIcon className="icon icon-close" onClick={onClickClose} />
            <Text
              dangerouslySetInnerHTML={{
                __html: t(`mobile_popup_m${random}`).replace(
                  t(`mobile_popup_m${random}_txt`),
                  `<span>${t(`mobile_popup_m${random}_txt`)}</span>`,
                ),
              }}
            />
            <ButtonRed onClick={onClickDownload}>
              <B1>{t("button_download2dub")}</B1>
            </ButtonRed>
          </Box>
        </Slide>
      </Wrapper>
    </Modal>
  );
};

const Wrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 16px;
  width: 100%;
`;

const PopupImage = styled.img`
  max-width: 328px;
`;

const Box = styled.div`
  position: relative;
  width: 328px;
  margin: 0 auto;
`;

const Text = styled(B1)`
  position: absolute;
  left: 50%;
  top: 264px;
  transform: translate(-50%, 0);
  width: 100%;
  padding: 0 16px;
  text-align: center;
  white-space: pre-wrap;
  color: var(--gray090);
  & span {
    color: var(--primary050);
    font-weight: 700;
  }
`;

const ButtonRed = styled.button`
  position: absolute;
  left: 50%;
  bottom: 32px;
  transform: translate(-50%, 0);
  width: 200px;
  height: 40px;
  border-radius: 18px;
  color: var(--white);
  background-color: var(--primary050);
  font-weight: 600;
  padding: 0;
  margin: 0;
  border: 0;
`;

const ButtonIcon = styled.button`
  position: absolute;
  bottom: 232px;
  right: 16px;
  font-size: 20px;
  color: var(--gray090);
  background-color: transparent;
  padding: 0;
  margin: 0;
  border: 0;
`;

export default Popup;
